export const TARGET_USERS: string[] = [
  'Maharsha.Nakkella.Contractor@pepsico.com',
  'Anand.VC.Contractor@pepsico.com',
  'Himanshu.Singh2.Contractor@pepsico.com',
].map((email) => email.toLowerCase());

// Users whose role is force-set to "Super User" on login, regardless of Okta claims.
export const SUPER_USER_OVERRIDE_EMAILS: string[] = [
  'RajeshKumar.Mohanty@pepsico.com',
].map((email) => email.toLowerCase());

interface NotificationContent {
  title: string;
  message: string;
}

export const SECTOR_CHANGES_LIST: Record<string, NotificationContent> = {
  'EMEA Foods': {
    title: 'Sector Consolidation Update',
    message: 'Sectors Europe and AMESA have been consolidated into EMEA Foods.',
  },
  'APAC Foods': {
    title: 'Sector Renaming Update',
    message: "Sector 'APAC' has been renamed to 'APAC Foods'.",
  },
  'LATAM Foods': {
    title: 'Sector Renaming Update',
    message: "Sector 'LATAM' has been renamed to 'LATAM Foods'.",
  },
  'North America': {
    title: 'Sector Consolidation Update',
    message: 'PBNA and PFNA have been consolidated into North America.',
  },
  'International Beverages': {
    title: 'Hierarchy Update',
    message:
      'APAC, Europe, LATAM and AMESA beverages moved under “International Beverages”​',
  },
};

export const ChangedSectorList = [
  'EMEA Foods',
  'APAC Foods',
  'LATAM Foods',
  'North America',
  'International Beverages',
];
